<script>
import { onMount } from "svelte";


import Input from "./Input.svelte";
import Select from "./Select.svelte"

export let defaultValue = "" // unused
export let value = null
export let debug = false

let emptyValue = "_"

let readableNumberValue = emptyValue
let readableUnitValue = ""

let defaultEnding = "px"

if (value !== null) {
    ["-", "px", "%", "rem", "em", "vw", "vh"].forEach(ending => {
        if (value !== null && value != 0) {
            if (value.includes(ending)) {
                defaultEnding = ending
                readableNumberValue = value.replace(ending, "").trim()
                value = readableNumberValue
                readableUnitValue = ending
            }
        }
    })
}

const isValidNumber = (value) => {
    return !isNaN(value)
}

$: {

    if (readableNumberValue == emptyValue) {
        readableUnitValue = ""
    } else {
        if (isValidNumber(readableUnitValue)) { // for some weird reason this works
            readableUnitValue = defaultEnding
        }
    }

    if (debug) {
        console.log("readableNumberValue", readableNumberValue)
        console.log("readableNumberValue", readableUnitValue)
        console.log("old value", value)
    }

    value = readableNumberValue + readableUnitValue

    if (debug) {
        console.log("new value", value)
        console.log("-----")
    }
}

let hasFocus = false

const onFocus = () => {
    hasFocus = true
    console.log("focused")
}

</script>

<div class="input-wrap">
    <Input focus={onFocus}  isValid={isValidNumber} defaultValue={emptyValue} defaultLabel={emptyValue} bind:value={readableNumberValue}/>
    <span class:hidden={!isValidNumber(readableNumberValue)}>
        <Select bind:value={readableUnitValue} labels={["-", "px", "%", "rem", "em", "vw", "vh"]} values={["", "px", "%", "rem", "em", "vw", "vh"]}/>
    </span>
</div>


<style>

</style>